import { render, staticRenderFns } from "./InstanceManagerModal.vue?vue&type=template&id=66c1537f&"
import script from "./InstanceManagerModal.vue?vue&type=script&lang=js&"
export * from "./InstanceManagerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports